import Packages from "../components/Pricing/Packages";
import TokenComparison from "../components/Pricing/TokenComparison";
import FeaturesComparison from "../components/Pricing/FeaturesComparison";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

export type Currency = "USD" | "INR";

const Pricing = () => {
  const { tab: urlTab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();

  const [pricingPlans, setPricingPlans] = useState([]);

  // Pricing is now a single credit-based page — every old per-module tab URL
  // (ai-screening, ai-talent-discovery, hiring-events, developer-platform,
  // and their older aliases ai-sourcing/campus-drives) collapses into
  // "/pricing" itself, so existing search ranking/links consolidate onto
  // this one canonical URL instead of 404ing.
  useEffect(() => {
    if (urlTab) {
      navigate("/pricing", { replace: true });
    }
  }, [urlTab, navigate]);

  useEffect(() => {
    getPricingPlans();
  }, []);

  const getPricingPlans = async () => {
    try {
      const response = await fetch(
        "https://interview.babblebots.ai/company/list_base_subscriptions_for_website/"
      );
      if (response?.ok) {
        try {
          const json = await response.json();
          if (json)
            if (json?.[0]?.additional_metadata?.order)
              setPricingPlans(
                (json || [])?.sort(
                  (a: any, b: any) =>
                    a.additional_metadata?.order - b.additional_metadata?.order
                )
              );
            else setPricingPlans(json);
        } catch (e) {
          console.error(e);
        }
      } else {
        throw new Error();
      }
    } catch (e) {
      return console.error(e);
    }
  };

  return (
    <main className="relative overflow-hidden">
      <div className="gradient-bg pointer-events-none absolute left-0 top-[15%] h-[100vh] w-full opacity-60 md:left-1/2 md:top-1/2 md:h-[65%] md:w-[65%] md:-translate-x-1/2 md:-translate-y-1/2" />
      <Packages />
      <TokenComparison />
      <FeaturesComparison />
    </main>
  );
};

export default Pricing;
